// removed by extract-text-webpack-plugin
module.exports = {"submenu-wrapper":"main_nav-1C0","submenu":"main_nav-2or","tablet-about":"main_nav-3_5","slideInDown":"main_nav-lRV","submenu-wrapper-active":"main_nav-3Pw","submenu-wrapper-background-override":"main_nav-2X4"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Submenu/submenu.module.scss
// module id = 361
// module chunks = 0